import { Chip as MuiChip, ChipProps } from '@mui/material';
import React from 'react';

const Chip = (props: ChipProps) => <MuiChip sx={{ borderRadius: '4px', padding: 0 }} {...props} />;

export default Chip;
